import React, { useState, useEffect } from "react";
import {
  Shield,
  Lock,
  Server,
  Database,
  Cloud,
  ArrowRight,
  CheckCircle,
  AlertCircle,
  Cpu,
  GitBranch,
  Key,
  FileText,
  Users,
  Sparkles,
} from "lucide-react";
import logo from "../assets/logo.png";
const HelpServiceInfo = () => {
  const [activeSection, setActiveSection] = useState(0);
  const [isVisible, setIsVisible] = useState({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible((prev) => ({ ...prev, [entry.target.id]: true }));
          }
        });
      },
      { threshold: 0.1 }
    );

    const sections = document.querySelectorAll(".animate-section");
    sections.forEach((section) => observer.observe(section));

    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-50">
      {/* Hero Section */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600/10 via-purple-600/10 to-blue-600/10"></div>
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-72 h-72 bg-blue-400/20 rounded-full filter blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-400/20 rounded-full filter blur-3xl animate-pulse delay-1000"></div>
        </div>

        <div className="relative container mx-auto px-6 py-24">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="flex-1 space-y-8">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-100 rounded-full text-blue-700 text-sm font-medium">
                <Sparkles className="w-4 h-4" />
                Enterprise AI Solution
              </div>

              <h1 className="text-5xl lg:text-7xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                Elva
              </h1>

              <p className="text-xl text-gray-600 leading-relaxed">
                기업용 프로토콜 기반 최적화된 AI 언어 모델 서비스
              </p>

              <div className="flex flex-wrap gap-4">
                <div className="flex items-center gap-2 text-gray-700">
                  <CheckCircle className="w-5 h-5 text-green-500" />
                  <span>차세대 멀티모달 AI 하이브리드 엔진 탑재</span>
                </div>
                <div className="flex items-center gap-2 text-gray-700">
                  <CheckCircle className="w-5 h-5 text-green-500" />
                  <span>MoE 아키텍처</span>
                </div>
                <div className="flex items-center gap-2 text-gray-700">
                  <CheckCircle className="w-5 h-5 text-green-500" />
                  <span>엔터프라이즈 보안</span>
                </div>
              </div>
            </div>

            <div className="flex-1 flex justify-center">
              <div className="relative w-80 h-80">
                {/* Elva Logo */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <img
                    src={logo}
                    alt="FreezeArchive"
                    className="animate-float"
                  />
                  {/* <svg
                    width="200"
                    height="200"
                    viewBox="0 0 200 200"
                    className="animate-float"
                  >
                    <defs>
                      <linearGradient
                        id="elvaGradient"
                        x1="0%"
                        y1="0%"
                        x2="100%"
                        y2="100%"
                      >
                        <stop offset="0%" stopColor="#3B82F6" />
                        <stop offset="50%" stopColor="#6366F1" />
                        <stop offset="100%" stopColor="#8B5CF6" />
                      </linearGradient>
                      <filter id="glow">
                        <feGaussianBlur
                          stdDeviation="10"
                          result="coloredBlur"
                        />
                        <feMerge>
                          <feMergeNode in="coloredBlur" />
                          <feMergeNode in="SourceGraphic" />
                        </feMerge>
                      </filter>
                    </defs>
                    <path
                      d="M100 30 C 60 30, 30 60, 30 100 C 30 140, 60 170, 100 170 C 120 170, 140 160, 150 140 L 130 120 C 120 130, 110 135, 100 135 C 80 135, 65 120, 65 100 C 65 80, 80 65, 100 65 C 110 65, 120 70, 130 80 L 150 60 C 140 40, 120 30, 100 30 Z"
                      fill="url(#elvaGradient)"
                      filter="url(#glow)"
                      className="drop-shadow-2xl"
                    />
                    <path
                      d="M110 90 L 130 70 C 140 80, 145 90, 145 100 C 145 110, 140 120, 130 130 L 110 110 C 115 105, 120 102, 120 100 C 120 98, 115 95, 110 90 Z"
                      fill="white"
                      opacity="0.9"
                    />
                  </svg> */}
                </div>
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-full filter blur-xl animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What is Elva Section */}
      <section id="what-is-elva" className="animate-section py-20 bg-white">
        <div className="container mx-auto px-6">
          <div
            className={`transition-all duration-1000 ${
              isVisible["what-is-elva"]
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-10"
            }`}
          >
            <h2 className="text-4xl font-bold text-center mb-16 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              Elva란 무엇인가요?
            </h2>

            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="space-y-6">
                <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-8 rounded-2xl border border-blue-100">
                  <h3 className="text-2xl font-semibold mb-4 text-gray-800">
                    고성능 AI 언어 모델
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    Elva는{" "}
                    <strong>Google과 AlibabaCloud의 검증된 오픈소스</strong>
                    &nbsp;Gemma-3 과 Qwen3-DeepThinker 를 기반으로,&nbsp;
                    <strong>기업 환경에 최적화된 미세 조정</strong>을 거친 AI
                    솔루션입니다.
                    <strong>MoE(Mixture of Experts) 아키텍처</strong>를 적용하여
                    특정 업무에서 ChatGPT∙Perplexity 등 최상위 언어 모델과
                    동등한 성능 을 구현합니다.
                  </p>
                </div>

                <div className="bg-gradient-to-r from-purple-50 to-blue-50 p-8 rounded-2xl border border-purple-100">
                  <h3 className="text-2xl font-semibold mb-4 text-gray-800">
                    기업 맞춤형 프로토콜
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    Elva는 <strong>내부 기업용 보안 프로토콜</strong>을 바탕으로
                    보안성과 고성능을 동시에 추구하며,
                    <strong>엔터프라이즈 환경에서 신뢰받는 AI 서비스</strong>를
                    지향합니다.
                  </p>
                </div>
              </div>

              <div className="relative">
                <div className="bg-gradient-to-br from-blue-100 to-purple-100 p-8 rounded-3xl shadow-2xl">
                  <div className="grid grid-cols-2 gap-6">
                    <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
                      <Cpu className="w-10 h-10 text-blue-600 mb-3" />
                      <h4 className="font-semibold text-gray-800">
                        MoE 아키텍처
                      </h4>
                      <p className="text-sm text-gray-600 mt-2">
                        효율적인 연산 처리
                      </p>
                    </div>
                    <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
                      <GitBranch className="w-10 h-10 text-purple-600 mb-3" />
                      <h4 className="font-semibold text-gray-800">미세조정</h4>
                      <p className="text-sm text-gray-600 mt-2">
                        기업별 최적화
                      </p>
                    </div>
                    <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
                      <Shield className="w-10 h-10 text-green-600 mb-3" />
                      <h4 className="font-semibold text-gray-800">
                        보안 프로토콜
                      </h4>
                      <p className="text-sm text-gray-600 mt-2">
                        데이터 안전 보장
                      </p>
                    </div>
                    <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
                      <Cloud className="w-10 h-10 text-indigo-600 mb-3" />
                      <h4 className="font-semibold text-gray-800">
                        클라우드 기반
                      </h4>
                      <p className="text-sm text-gray-600 mt-2">
                        확장 가능한 서비스
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-12 p-6 bg-amber-50 border border-amber-200 rounded-xl">
              <div className="flex items-start gap-4">
                <AlertCircle className="w-6 h-6 text-amber-600 flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-semibold text-gray-800 mb-2">
                    사용 시 유의사항
                  </h4>
                  <p className="text-gray-600">
                    AI 모델의 특성상 출력 결과는 때때로 오류를 포함할 수
                    있습니다. 중요한 의사결정에는 반드시 전문가의 검토를 거쳐
                    사용하시기 바랍니다.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Security Section */}
      <section
        id="security"
        className="animate-section py-20 bg-gradient-to-br from-slate-50 to-blue-50"
      >
        <div className="container mx-auto px-6">
          <div
            className={`transition-all duration-1000 ${
              isVisible["security"]
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-10"
            }`}
          >
            <h2 className="text-4xl font-bold text-center mb-16 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              철저한 보안 시스템
            </h2>

            <div className="grid lg:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-blue-100">
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                  <Lock className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold mb-4 text-gray-800">
                  보안 마스킹
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  기업 내부 정보는 AI 처리 과정에서 자동으로 마스킹 처리되며,
                  학습 데이터로 사용되지 않습니다.
                </p>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-purple-100">
                <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                  <Key className="w-8 h-8 text-purple-600" />
                </div>
                <h3 className="text-xl font-semibold mb-4 text-gray-800">
                  암호화 기술
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  AES-256 + ECC P-256 암호화와 외부 KMS를 통한 관리자 키
                  시스템으로 데이터를 보호합니다.
                </p>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-green-100">
                <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                  <Database className="w-8 h-8 text-green-600" />
                </div>
                <h3 className="text-xl font-semibold mb-4 text-gray-800">
                  데이터 정책
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  입출력 데이터는 기본적으로 저장되지 않으며, 필요시에만
                  암호화되어 임시 보관됩니다.
                </p>
              </div>
            </div>
            <div className="mt-12 bg-gradient-to-r from-blue-600 to-purple-600 p-1 rounded-2xl">
              <div className="bg-white p-8 rounded-2xl">
                <h3 className="text-2xl font-semibold mb-6 text-center text-gray-800">
                  보안 아키텍처
                </h3>

                {/* Architecture Flow */}
                <div className="max-w-4xl mx-auto">
                  <div className="flex items-center justify-between flex-wrap gap-8">
                    {/* User */}
                    <div className="flex-1 min-w-[200px]">
                      <div className="bg-gradient-to-br from-indigo-50 to-blue-50 p-6 rounded-2xl border border-indigo-200 shadow-lg hover:shadow-xl transition-all duration-300">
                        <div className="flex flex-col items-center space-y-3">
                          <div className="w-16 h-16 bg-gradient-to-br from-indigo-500 to-blue-500 rounded-full flex items-center justify-center shadow-lg">
                            <Users className="w-8 h-8 text-white" />
                          </div>
                          <h4 className="font-semibold text-gray-800">
                            사용자
                          </h4>
                          <p className="text-sm text-gray-600 text-center">
                            데이터 입력
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Arrow 1 */}
                    <div className="flex items-center">
                      <ArrowRight className="w-8 h-8 text-gray-400" />
                    </div>

                    {/* Encryption Layer */}
                    <div className="flex-1 min-w-[200px]">
                      <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-6 rounded-2xl border border-blue-200 shadow-lg hover:shadow-xl transition-all duration-300">
                        <div className="flex flex-col items-center space-y-3">
                          <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-full flex items-center justify-center shadow-lg">
                            <Lock className="w-8 h-8 text-white" />
                          </div>
                          <h4 className="font-semibold text-gray-800">
                            암호화 계층
                          </h4>
                          <div className="space-y-1">
                            <p className="text-xs text-gray-600 text-center bg-blue-100 px-3 py-1 rounded-full">
                              AES-256
                            </p>
                            <p className="text-xs text-gray-600 text-center bg-cyan-100 px-3 py-1 rounded-full">
                              ECC P-256
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Arrow 2 */}
                    <div className="flex items-center">
                      <ArrowRight className="w-8 h-8 text-gray-400" />
                    </div>

                    {/* Elva Core */}
                    <div className="flex-1 min-w-[200px]">
                      <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-2xl border border-purple-200 shadow-lg hover:shadow-xl transition-all duration-300">
                        <div className="flex flex-col items-center space-y-3">
                          <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center shadow-lg">
                            <Cpu className="w-8 h-8 text-white" />
                          </div>
                          <h4 className="font-semibold text-gray-800">
                            Elva Core
                          </h4>
                          <div className="space-y-2 w-full">
                            <div className="flex items-center justify-center gap-2 bg-purple-100 px-3 py-1 rounded-full">
                              <Shield className="w-3 h-3 text-purple-600" />
                              <p className="text-xs text-gray-700">
                                마스킹 처리
                              </p>
                            </div>
                            <div className="flex items-center justify-center gap-2 bg-pink-100 px-3 py-1 rounded-full">
                              <Sparkles className="w-3 h-3 text-pink-600" />
                              <p className="text-xs text-gray-700">AI 처리</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Arrow 3 */}
                    <div className="flex items-center">
                      <ArrowRight className="w-8 h-8 text-gray-400" />
                    </div>

                    {/* KMS */}
                    <div className="flex-1 min-w-[200px]">
                      <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-2xl border border-green-200 shadow-lg hover:shadow-xl transition-all duration-300">
                        <div className="flex flex-col items-center space-y-3">
                          <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-500 rounded-full flex items-center justify-center shadow-lg">
                            <Key className="w-8 h-8 text-white" />
                          </div>
                          <h4 className="font-semibold text-gray-800">KMS</h4>
                          <p className="text-sm text-gray-600 text-center">
                            키 관리 시스템
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Additional Info */}
                  <div className="mt-12 grid md:grid-cols-3 gap-6">
                    <div className="bg-blue-50 p-4 rounded-xl border border-blue-200">
                      <div className="flex items-start gap-3">
                        <Database className="w-5 h-5 text-blue-600 mt-1" />
                        <div>
                          <h5 className="font-medium text-gray-800 mb-1">
                            데이터 정책
                          </h5>
                          <p className="text-xs text-gray-600">
                            기본적으로 데이터는 저장되지 않습니다
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-purple-50 p-4 rounded-xl border border-purple-200">
                      <div className="flex items-start gap-3">
                        <Server className="w-5 h-5 text-purple-600 mt-1" />
                        <div>
                          <h5 className="font-medium text-gray-800 mb-1">
                            처리 과정
                          </h5>
                          <p className="text-xs text-gray-600">
                            모든 데이터는 실시간 마스킹 처리
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-green-50 p-4 rounded-xl border border-green-200">
                      <div className="flex items-start gap-3">
                        <Shield className="w-5 h-5 text-green-600 mt-1" />
                        <div>
                          <h5 className="font-medium text-gray-800 mb-1">
                            보안 수준
                          </h5>
                          <p className="text-xs text-gray-600">
                            엔터프라이즈급 암호화 적용
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Data Policy Section */}
      <section id="data-policy" className="animate-section py-20 bg-white">
        <div className="container mx-auto px-6">
          <div
            className={`transition-all duration-1000 ${
              isVisible["data-policy"]
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-10"
            }`}
          >
            <h2 className="text-4xl font-bold text-center mb-16 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              데이터 처리 정책
            </h2>

            <div className="max-w-4xl mx-auto space-y-8">
              <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-8 rounded-2xl border border-blue-100">
                <h3 className="text-2xl font-semibold mb-6 text-gray-800 flex items-center gap-3">
                  <FileText className="w-6 h-6 text-blue-600" />
                  데이터 저장 정책
                </h3>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
                    <span className="text-gray-700">
                      기본적으로 입력값 및 출력값은 Elva 내부에 저장되지
                      않습니다
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
                    <span className="text-gray-700">
                      번역, 문서 채팅 등 다운로드가 필요한 경우에만 임시
                      저장됩니다
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
                    <span className="text-gray-700">
                      세션이 종료되면 모든 임시 데이터는 자동으로 삭제됩니다
                    </span>
                  </li>
                </ul>
              </div>

              <div className="bg-gradient-to-r from-amber-50 to-orange-50 p-8 rounded-2xl border border-amber-200">
                <h3 className="text-2xl font-semibold mb-6 text-gray-800 flex items-center gap-3">
                  <AlertCircle className="w-6 h-6 text-amber-600" />
                  중요 안내사항
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  사용자가 실수로 데이터를 삭제할 경우,
                  <strong>백업 미보관 정책</strong>으로 인해 복구가
                  불가능합니다.
                  <strong>중요 데이터는 반드시 별도 저장</strong>해 주시기
                  바랍니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Roadmap Section */}
      <section
        id="roadmap"
        className="animate-section py-20 bg-gradient-to-br from-blue-50 to-purple-50"
      >
        <div className="container mx-auto px-6">
          <div
            className={`transition-all duration-1000 ${
              isVisible["roadmap"]
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-10"
            }`}
          >
            <h2 className="text-4xl font-bold text-center mb-16 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              향후 로드맵
            </h2>

            <div className="max-w-5xl mx-auto">
              <div className="bg-white p-10 rounded-3xl shadow-xl border border-purple-100">
                <h3 className="text-2xl font-semibold mb-8 text-center text-gray-800">
                  Multi-Agent 시스템 구축
                </h3>

                <div className="grid lg:grid-cols-2 gap-8 mb-10">
                  <div className="space-y-6">
                    <h4 className="text-lg font-semibold text-gray-700 flex items-center gap-2">
                      <Users className="w-5 h-5 text-blue-600" />
                      협력 AI 모델
                    </h4>
                    <div className="space-y-3">
                      <div className="flex items-center gap-3 p-3 bg-blue-50 rounded-lg">
                        <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                        <span className="text-gray-700">
                          TGL - 다국어 고급 번역 특화 모델
                        </span>
                      </div>
                      <div className="flex items-center gap-3 p-3 bg-purple-50 rounded-lg">
                        <div className="w-2 h-2 bg-purple-600 rounded-full"></div>
                        <span className="text-gray-700">
                          Ash - 대용량 파일 분석 특화 모델
                        </span>
                      </div>
                      <div className="flex items-center gap-3 p-3 bg-green-50 rounded-lg">
                        <div className="w-2 h-2 bg-green-600 rounded-full"></div>
                        <span className="text-gray-700">
                          GRD - 인간 친화적인 질문 의도 분석 모델
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="space-y-6">
                    <h4 className="text-lg font-semibold text-gray-700 flex items-center gap-2">
                      <GitBranch className="w-5 h-5 text-purple-600" />
                      프로토콜 확장
                    </h4>
                    <div className="space-y-3">
                      <div className="p-4 bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg border border-blue-200">
                        <h5 className="font-medium text-gray-800 mb-1">
                          A2A 프로토콜
                        </h5>
                        <p className="text-sm text-gray-600">
                          AI 에이전트 간 직접 통신
                        </p>
                      </div>
                      <div className="p-4 bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg border border-purple-200">
                        <h5 className="font-medium text-gray-800 mb-1">
                          MCP 프로토콜
                        </h5>
                        <p className="text-sm text-gray-600">
                          다중 컨텍스트 처리
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-indigo-50 to-blue-50 p-6 rounded-xl border border-indigo-200">
                  <h4 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
                    <Shield className="w-5 h-5 text-indigo-600" />
                    보안 유지
                  </h4>
                  <p className="text-gray-700 leading-relaxed">
                    Multi-Agent 시스템에서 <strong>Gemini 등 외부 LLM</strong>은
                    에이전트 선정 기능만 수행하며, 실제 데이터 처리나 저장에는
                    관여하지 않습니다.
                    <br /> 모든 기업 정보는 Elva 프로토콜에 따라&nbsp;
                    <strong>실시간 마스킹 처리</strong>되어 전송되며, 에이전트
                    간 통신 과정에서도 기밀성이 철저히 유지됩니다.
                  </p>
                </div>
              </div>

              {/* Timeline */}
              <div className="mt-12 relative">
                <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-blue-400 to-purple-400"></div>

                <div className="space-y-8">
                  <div className="relative flex items-center">
                    <div className="flex-1 text-right pr-8">
                      <h4 className="font-semibold text-gray-800">Phase 1</h4>
                      <p className="text-gray-600">
                        기본 Multi-Agent 프레임워크 구축
                      </p>
                    </div>
                    <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-blue-500 rounded-full"></div>
                    <div className="flex-1 pl-8"></div>
                  </div>

                  <div className="relative flex items-center">
                    <div className="flex-1 pr-8"></div>
                    <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-purple-500 rounded-full"></div>
                    <div className="flex-1 pl-8">
                      <h4 className="font-semibold text-gray-800">Phase 2</h4>
                      <p className="text-gray-600">A2A & MCP 프로토콜 구현</p>
                    </div>
                  </div>

                  <div className="relative flex items-center">
                    <div className="flex-1 text-right pr-8">
                      <h4 className="font-semibold text-gray-800">Phase 3</h4>
                      <p className="text-gray-600">
                        전체 시스템 통합 및 최적화
                      </p>
                    </div>
                    <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-indigo-500 rounded-full"></div>
                    <div className="flex-1 pl-8"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      {/* <section className="py-20 bg-gradient-to-r from-blue-600 to-purple-600">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            엔터프라이즈 AI의 새로운 기준
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Elva와 함께 더 안전하고 효율적인 AI 서비스를 경험하세요
          </p>
          <button className="bg-white text-blue-600 px-8 py-4 rounded-full font-semibold text-lg hover:bg-blue-50 transition-colors duration-300 shadow-lg hover:shadow-xl">
            시작하기 <ArrowRight className="inline-block ml-2 w-5 h-5" />
          </button>
        </div>
      </section> */}
    </div>
  );
};

export default HelpServiceInfo;
